module.exports = __webpack_public_path__ + "static/media/no_data.5fdf39f7.svg";